// @flow
import type { ErrorT } from './Error.type'

export function isJson (response: Response) {
  const contentType = response.headers.get('content-type')
  return contentType && contentType.indexOf('application/json') !== -1
}

export function handleResponse (response: Response): Promise<any> {
  if (response.ok) {
    if (isJson(response)) {
      return response.json()
    } else {
      return (response.text() : Promise<any>)
    }
  } else {
    const error: ErrorT = new Error(response.statusText)
    error.response = response
    throw error
  }
}

export function handleError (reject: Function, dispatch: Function, errAction: Function) {
  return function (err: ErrorT) {
    if (err.response && isJson(err.response)) {
      err.response.json()
        .then((errBody) => {
          err.body = errBody
          reject(err)
          dispatch(errAction(err))
        })
    } else {
      reject(err)
      dispatch(errAction(err))
    }
  }
}

export function handleData (resolve: Function, dispatch: Function, action: Function) {
  return function (data: any) {
    resolve(data)
    dispatch(action(data))
  }
}
